/**
 * Created by sswaminathan on 1/8/22
 * File: LicenseProductList
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { FF_ENABLE_BACKBONE } from '../../../common/utils/FeatureFlags'
import { getVarValue } from '../../../common/utils/Sparky'
import {
  PRODUCT_LISTINGS, PRODUCT_PARAMETERS
} from '../constants/SubscriptionConstant'
/**
 *   TODO: Brief what is this component/class do
 */
import AddonListings from './productListings/AddonListings'
import BackboneListing from './productListings/sections/BackboneListing'
const LicenseProductList = (props) => {
  const { item, isBackBoneInstanceAvailable } = props
  const isBackboneEnabled = getVarValue(FF_ENABLE_BACKBONE, false)
  return <div className='tw-pl-4'>
    {PRODUCT_LISTINGS.map((each, index) => {
      if (each !== 'bundledApps') {
        return <AddonListings key={`${index}-${each}`}
          {...{
            ...PRODUCT_PARAMETERS[each],
            ...props,
            itemList: item[each],
            indexKey: each
          }}
        />
      }
      else {
        return item.bundledApps ? Object.keys(item.bundledApps).map((each, idx) => {
          return <AddonListings
            key={`${index}-${each}-Bundle`}
            header={each}
            isBundle={true}
            itemList={item.bundledApps[each]}
            {...props}/>
        }) : <></>
      }
    })}
    {(isBackboneEnabled && isBackBoneInstanceAvailable) && <BackboneListing {...{ ...props }}/>}
    {/*{(isBackboneEnabled && true) && <BackboneListing {...{ props }}/>}*/}
  </div>
}

LicenseProductList.propTypes = {}
export default LicenseProductList
